import { Button } from 'dingtalk-design-mobile';
import './SubmitStatus.less'
// import { _test } from '../../api/user';
// import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom'
import useHistory from '@/hooks/useHistory'

const SubmitStatus = () => {
  const history = useHistory()
  const [ params ] = useSearchParams()
  const id = params.getAll('id')[0]

  // useEffect(() => {
  //   _test()
  // }, [])

  const goDetail = () => {
    history.push('/AdviceDetail?id=' + id, 'route')
  }
  const goBack = () => {
    history.back(1)
  }
  return (
    <div className='pg-sumbit-success'>
      <img className='header' src='https://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/advice/advice-header.png' />
      <div className='pg-sumbit-success--wrap'>
        <div className='pg-sumbit-success--container'>
          <img className='icon' src='https://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/advice/success-icon.png' />
          <div className='content'>提交成功</div>
          <Button className='btn detail-btn' onClick={goDetail}>查看详情</Button>
          <Button className='btn' onClick={goBack}>继续建言</Button>
        </div>
      </div>
    </div>
  )
}

export default SubmitStatus;